export default [
  {
    path: '/configurar/',
    name: 'configurar',
    title: 'configurar',
    component: () => import('../view/ConfiguracaoView.vue'),
    redirect: { name: 'configurar-tela' },
    children: [
      {
        path: 'tela',
        name: 'configurar-tela',
        component: () => import('../etradeWebConfig/view/EtradeWebSaidaConfig.vue'),
        meta: {
          title: 'configurar tela',
        },
      },
    ],
  },
];
